import React, {useContext} from "react";
import {Store} from "../../Utils/Store";
import {Link} from "react-router-dom";
import Tech_ul from "./Tech_ul";

function Footer() {
    const {state} = useContext(Store)
    const {ContactInfo} = state
    return (
        <>
            <footer className="footer-one">
                {/* Start Footer Main */}
                <div className="footer-main">
                    <div className="container">
                        <div className="row">
                            {/*Start Single Footer Widget*/}
                            <div
                                className="col-xl-4 col-lg-6 col-md-6 wow animated fadeInUp"
                                data-wow-delay="0.1s"
                                style={{
                                    visibility: "hidden",
                                    animationDelay: "0.1s",
                                    animationName: "none"
                                }}
                            >
                                <div className="single-footer-widget">
                                    <div className="our-company-info">
                                        <div className="footer-logo-one">
                                            <Link to="index.html">
                                                <img width="180px" src="assets/img/resource/logo.png" alt="Logo"/>
                                            </Link>
                                        </div>
                                        <div className="text">
                                            <p>
                                                We deliver innovative software and AI solutions tailored to empower
                                                businesses and drive success.
                                            </p>

                                        </div>
                                        <div className="footer-social-link">
                                            <ul className="clearfix">
                                                <li>
                                                    <Link to={ContactInfo.facebook}>
                                                        <i className="icon-facebook"/>
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to={ContactInfo.twitter}>
                                                        <i className="icon-twitter"/>
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to={ContactInfo.instagram}>
                                                        <i className="icon-instagram"/>
                                                    </Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/*End Single Footer Widget*/}
                            {/*Start Single Footer Widget*/}
                            <div
                                className="col-xl-4 col-lg-6 col-md-6 wow animated fadeInUp"
                                data-wow-delay="0.2s"
                                style={{
                                    visibility: "hidden",
                                    animationDelay: "0.2s",
                                    animationName: "none"
                                }}
                            >
                                <div className="single-footer-widget ml50">
                                    <div className="title">
                                        <h3>More Links</h3>
                                    </div>
                                    <div className="footer-widget-links">
                                        <ul className="navigation">
                                            <li><Link to="/ai-models" >AI Models</Link></li>
                                            <li><Link to="/projects" >Projects</Link></li>
                                            <li><Link to="/services" >Services</Link></li>
                                            <li><Link to="/about-us" >About Us</Link></li>
                                            <li><Link to="/contact-us" >Contact Us</Link></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            {/*End Single Footer Widget*/}
                            {/*Start Single Footer Widget*/}
                            <div
                                className="col-xl-4 col-lg-6 col-md-6 wow animated fadeInUp"
                                data-wow-delay="0.3s"
                                style={{
                                    visibility: "hidden",
                                    animationDelay: "0.3s",
                                    animationName: "none"
                                }}
                            >
                                <div className="single-footer-widget mt60">
                                <div className="title">
                                        <h3>Address</h3>
                                    </div>
                                    <div className="footer-widget-contact-info">
                                        <ul>
                                            <li>
                                                <div className="icon-box">
                                                    <span className="icon-paper-plane"/>
                                                </div>
                                                <div className="text-box">
                                                    <p>
                                                        {ContactInfo.address}
                                                    </p>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="icon-box">
                                                    <span className="icon-envelope"/>
                                                </div>
                                                <div className="text-box">
                                                    <p>
                                                        <Link to={`mailto:${ContactInfo.contact_email}`}>
                                                            {ContactInfo.contact_email}
                                                        </Link>
                                                        <br/>
                                                        <Link to={`mailto:${ContactInfo.contact_email2}`}>
                                                            {ContactInfo.contact_email2}
                                                        </Link>
                                                    </p>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="icon-box">
                                                    <span className="icon-call"/>
                                                </div>
                                                <div className="text-box">
                                                    <p>
                                                        <Link
                                                            to={`tel:${ContactInfo.contact_phone}`}>{ContactInfo.contact_phone}</Link>
                                                        <br/>
                                                        <Link
                                                            to={`tel:${ContactInfo.contact_phone2}`}>{ContactInfo.contact_phone2}</Link>
                                                    </p>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            {/*End Single Footer Widget*/}

                        </div>
                    </div>
                </div>
                {/* End Footer Main */}
                {/* Footer Bottom Start */}
                <div className="footer-bottom">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-xl-6 col-lg-6">
                                <div className="copyright-text">
                                    <p>© Zaala Society 2024 | All Rights Reserved</p>
                                </div>
                            </div>
                            <div className="col-xl-6 col-lg-6 text-end">
                                <div className="copyright-menu">
                                    <ul>

                                        <li>
                                            <Link to="/about-us">About Us</Link>
                                        </li>
                                        <li>
                                            <Link to="/contact-us">Contact Us</Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Footer Bottom End */}
            </footer>

        </>
    );
}

export default Footer;
